import { lightTheme } from '@/customTheme'
import { styled } from 'baseui'
import React from 'react'

interface ThumbnailBorderProps {
  selected: boolean
  isActive: boolean
  isLoading: boolean
  children?: React.ReactNode
}

const Container = styled('div', {
  position: 'relative',
  width: '100%',
  height: '100%',
})

const overlayStyle = {
  position: 'absolute' as const,
  inset: 0,
  borderRadius: '8px',
  pointerEvents: 'none' as const,
  zIndex: 1,
}

const ThumbnailBorder: React.FC<ThumbnailBorderProps> = ({ selected, isActive, isLoading, children }) => {
  const borderShadow = selected
    ? (isActive ? '0 0 0 2px rgba(255, 5, 96, 1) inset' : `0 0 0 2px ${lightTheme.colors.grayScale600} inset`)
    : `0 0 0 1px ${lightTheme.colors.grayScale100} inset`

  return (
    <Container>
      {children}
      {!isLoading && (
        <>
          {selected && <div style={{ ...overlayStyle, boxShadow: 'inset 0 0 0 4px white' }} />}
          <div style={{ ...overlayStyle, boxShadow: borderShadow }} />
        </>
      )}
    </Container>
  )
}

export default ThumbnailBorder
